import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const AVAILABLE_ACCOUNT_THEMES = ['default', 'whatsapp'];

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};

export const setAccountTheme = themeName => {
  const theme = AVAILABLE_ACCOUNT_THEMES.includes(themeName)
    ? themeName
    : 'default';
  AVAILABLE_ACCOUNT_THEMES.forEach(name =>
    document.body.classList.remove(`theme-${name}`)
  );
  document.body.classList.add(`theme-${theme}`);
};
